export default __webpack_public_path__ + "static/media/noimg.03935fc7.png";